
import { Contact } from '@/@types/responses/contact/Contact'
import { defineComponent } from 'vue'
import DotsSvg from '@/components/svgs/DotsSvg.vue'

export default defineComponent({
  name: 'ContactTile',
  components: {
    DotsSvg
  },
  props: {
    contact: {
      type: Contact,
      required: true
    }
  },
  emits: ['delete', 'edit'],
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    closeMenu(): void {
      this.showMenu = false
    },
    onDeleteContactClicked(): void {
      this.closeMenu()
      this.$emit('delete', this.contact)
    },
    onDotsClicked(): void {
      this.showMenu = true
    },
    onEditContactClicked(): void {
      this.closeMenu()
      this.$emit('edit', this.contact)
    }
  }
})
